/**   
 * api接口统一管理
 */
import {
	get,
	post,
	put,
	Delete
} from './http'


export const apiLogin = p => post('/login', p);  //密码登录接口
export const apiPhoneLogin = p => post('/phoneLogin', p);  //手机号登录接口
export const apiSendMsg = p => get('/send/msg', p);  //获取验证码
export const apiGetInfo = p => get('/getInfo', p);  //获取身份信息
export const apiCommonUpload = p => post('/common/upload',p); //文件上传
export const apiFundationImg = p => post('/system/image', p);  //新增首页图片
export const apiAllSchoolTreeselect = p => get('/system/dept/treeselect',p);//所有校区下拉列表
export const apiAllSchoolList = p => get('/system/dept/list',p);//加盟校区列表
export const apiAddSchool= p => post('/system/dept',p); //新增加盟校区
export const apiEdtorchool = p => put('/system/dept',p); //修改校区
export const apiAllSubjectList = p => get('/system/table/list',p);//科目列表
export const apiAddSubject = p => post('/system/table',p); //新增科目
export const apiDeleSubject= p => Delete('/system/table',p); //删除科目
export const apiEdtorSubject = p => put('/system/table',p); //编辑科目
export const apiImageList = p => get('/system/image/list',p); //欢迎页图片
export const apiFirstSubjectList = p => get('/system/table/firstSubjectList',p); //查看一级科目
export const apiTwoSubjectList = p => get('/system/table/twoSubjectList',p); //查看二级科目
export const apiThreeSubjectList = p => get('/system/table/threeSubjectList',p); //查看三级科目
export const apiCoursewareList = p => get('/system/table/subCourseList',p); //获取指定三级科目课件信息
export const apiCoursewareInfo = p => get('/system/courseware',p); //获取课件详细信息
export const apiGetsubNameList = p => get('/system/table/getsubNameList',p); //新增课件科目下拉框值
export const apiDeleCourseware = p => Delete('/system/courseware',p); //删除课件
export const apiAddCourseware = p => post('/system/courseware',p); //新增课件
export const apiEdtorCourseware = p => put('/system/courseware',p); //修改课件
export const apiAddResource = p => post('/system/resource',p); //新增文件
export const apiEdtorResource = p => put('/system/resource',p); //修改课件文件资源
export const apiDeleResource= p => Delete('/system/resource',p); //删除课件文件资源
export const apiTeachFeedbackList = p => get('/system/feedback/list',p); //教师反馈列表查询
export const apiAddTeachFeedback = p => post('/system/feedback',p); //教师新增反馈
export const apiTeachFeedbackCouseList = p => get('/system/courseware/CourseConfig',p); //教师新增反馈-或者课件下拉列表
export const apiSystemUserList = p => get('/system/user/list',p); //用户列表
export const apiAddUser = p => post('/system/user',p); //新增用户适用于管理员新增子管理员，加盟校区新增子管理员
export const apiEidtorUser = p => put('/system/user',p); //修改用户适用于管理员新增子管理员，加盟校区新增子管理员
export const apiSystemdeptSchoolList = p => get('/system/dept/getlist',p); //用户管理配置的所属校区下拉
export const apiSystemdeptUserTypeList = p => get('/system/dept/getUserType',p); //用户管理配置的角色下拉
export const apiSystemTeachLogList = p => get('/system/apply/list',p); //课件日志
export const apiAddSystemTeachLog = p => post('/system/apply',p); //新增课件日志
export const apiEditorSystemTeachLog = p => put('/system/apply',p); //修改课件日志
export const apiBatchEdit = p => get('/system/apply/batchEdit',p); //批量审核课件日志
export const apiTeacherThreeList = p => get('/system/courseware/subOrCourlist',p); //教师的三级课件列表
export const apiMsgList= p => get('/system/messages/list',p);  //查看消息
export const apiResetPwd = p => put('/system/user/resetPwd',p); //修改密码
export const apiSaveCourseConfig = p => post('/system/courseware/save/CourseConfig',p); //修改密码

export const apiFindSubject = p => get('/system/table/find/subject',p); // 查询所有一级科目
export const apiUserAssociationName = p => get('/system/user/associationName',p); //  增加姓名搜索，关键词关联



// WEBPACK FOOTER //
// ./src/request/api.js